import React, { useState } from 'react';
import { useIntl, useSelector, useDispatch } from 'umi';
import { Modal, Button, Form, Input } from 'tea-component';
import { ModalPrposType } from './ModalWrap';
import { addMenu, updateMenu } from '@/pages/dashboard/services/leftMenu';
import { useNameHooks } from './hooks';
export default (props: ModalPrposType) => {
  const { modalInfo: {show, type, item = {}}, close } = props;
  const [loading, setLoading] = useState<boolean>(false); // loading

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const {
    nameCN,
    setNameCN,
    nameEN,
    setNameEN,
    nameENErr,
    setNameENErr,
    nameCNErr,
    checkNameEN,
    checkNameCN
  } = useNameHooks(item, formatMessage,'menu');

  const isNull = !nameEN
  const isError = nameENErr || nameCNErr;

  const { currentGame} = useSelector(state => {
    // @ts-ignore
    const { currentGame} = state.dashboard;
    return {
      currentGame
    }
  });

  // 添加菜单
  const doAddMenu = () => {
    setLoading(true);
    const { game_code: gameCode, role_type: roleType, studio_code: studioCode  } = currentGame || {};
    addMenu({
      menu_type: 0,
      name_en: nameEN,
      name_cn: nameCN,
      game_code: gameCode,
      role_type: roleType,
      studio_code: studioCode,
      user_id: ""
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
        payload: {
          currentGame
        }
      });
      close();
    }, (err) => {
      const { msg,code } = err;
      //本期只有一种状态 code：30011：代表重复，但是不能区分是哪个业务的重复，所以写不了配置文件，暂时在代码逻辑中处理
      const codeToMsg = code ===30011 ? formatMessage({id:'menu_menu_re_enter'}) : msg
      setNameENErr(codeToMsg);
    }).finally(() => {
      setLoading(false);
    });
  }

  // 更新菜单
  const doUpdateMenu = () => {
    setLoading(true);
    const { game_code: gameCode } = currentGame || {};
    updateMenu({
      name_en: nameEN,
      name_cn: nameCN,
      game_code: gameCode,
      u_id: item.id
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
        payload: {
          currentGame
        }
      });
      close();
    }, (err) => {
      const { msg,code } = err;
      //本期只有一种状态 code：30011：代表重复，但是不能区分是哪个业务的重复，所以写不了配置文件，暂时在代码逻辑中处理
      const codeToMsg = code ===30011 ? formatMessage({id:'menu_menu_re_enter'}) : msg
      setNameENErr(codeToMsg);
    }).finally(() => {
      setLoading(false);
    });
  }

  // 点击confirm 按钮
  const handleClickConfirm = () => {
    if (!checkNameEN() || !checkNameCN() || loading) {
      return;
    }
    if (type === 'add') {
      doAddMenu();
    } else if (type === 'edit') {
      doUpdateMenu();
    }
  }

  return (
    <>
      <Modal.Body>
        <Form>
          <Form.Item
            showStatusIcon={false}
            required={true}
            label={formatMessage({id: 'menu'}) + formatMessage({id: 'name'})}
            status={nameENErr ? 'error' : undefined}
            message={nameENErr}>
            <Input style={{ width: '100%' }} value={nameEN} onChange={(val) => {setNameEN(val)}} onBlur={checkNameEN} placeholder={formatMessage({id: 'menu_enter_menu_name'})}/>
          </Form.Item>
          <Form.Item
            showStatusIcon={false}
            label={formatMessage({id: 'chinese'}) + formatMessage({id: 'name'})}
            status={nameCNErr? 'error' : undefined}
            message={nameCNErr}>
            <Input style={{ width: '100%' }} value={nameCN} onChange={(val) => {setNameCN(val)}} onBlur={checkNameCN} placeholder={formatMessage({id: 'menu_enter_menu_ch_name'})}/>
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button loading={loading} type="primary" disabled={isNull || Boolean(isError)} onClick={handleClickConfirm}>{formatMessage({id:'menu_confirm'})}</Button>
        <Button type="weak" onClick={close}>{formatMessage({id:'menu_cancel'})}</Button>
      </Modal.Footer>
    </>
  );
}
